// extracted by mini-css-extract-plugin
export default {"right":"SettingsCol_right__VnKvw","list":"SettingsCol_list__S4lbc","fullWidth":"SettingsCol_fullWidth__t7p3S"};